/**
 * Fallback colour (hex digits, no '#') for a region whose `General.Color` is
 * missing or not a hex string. Same grey as `GraphicsMaterials.greyInspectionMaterial`.
 */
export const DEFAULT_REGION_COLOR_HEX = '8A8A8A';

/**
 * Hex digits (no '#') for a region colour, so a null/empty/invalid
 * `General.Color` falls back to {@link DEFAULT_REGION_COLOR_HEX} instead of
 * throwing (UAT 2 N1: a created region with `Color = null` threw in
 * `createRegionsMaterials`, and the digital-twin catch-all logged the user out).
 * Valid hex input is returned unchanged apart from the leading '#'.
 */
export function regionColorHex(color: string | null | undefined): string {
  if (typeof color !== 'string') return DEFAULT_REGION_COLOR_HEX;
  const hex = color.trim().replace('#', '');
  return /^[0-9a-fA-F]{1,6}$/.test(hex) ? hex : DEFAULT_REGION_COLOR_HEX;
}
